import { Link } from 'react-router';
import { useStaticPages } from '../../api/queryHooks/account';
import type { PageLinksBlock } from '../../api/staticPageBlocks';

const PageLinksBlockView = ({ block }: { block: PageLinksBlock }) => {
  const { data: pages } = useStaticPages();
  const bySlug = new Map((pages ?? []).map((p) => [p.slug, p]));
  const resolved = block.links
    .map((l) => ({ ...l, page: bySlug.get(l.slug) }))
    .filter((l) => l.page);
  if (resolved.length === 0) return null;
  return (
    <div className="block-page-links buttons">
      {resolved.map((l) => (
        <Link key={l.slug} className="button is-link is-light" to={`/page/${l.slug}`}>
          {l.label || l.page?.title}
        </Link>
      ))}
    </div>
  );
};

export default PageLinksBlockView;
